module.exports = __webpack_public_path__ + "img/Enssib-logo.de16ff61.svg";